<template>
	<div>
		<div class="top bg-size">
			<img class="top-title" src="@/assets/title_main.png"/>
			<!-- 左侧呼吸灯 -->
			<div class="breathing-light left-light">
				<div 
					class="light-block" 
					v-for="(color, index) in colors" 
					:key="index"
					:style="{ 
						animationDelay: (index * 0.3) + 's, ' + (index * 0.5) + 's'
					}"
				></div>
			</div>
			<!-- 右侧呼吸灯 -->
			<div class="breathing-light right-light">
				<div 
					class="light-block right-block" 
					v-for="(color, index) in colors" 
					:key="index"
					:style="{ 
						animationDelay: ((colors.length - 1 - index) * 0.3) + 's, ' + ((colors.length - 1 - index) * 0.5) + 's'
					}"
				></div>
			</div>
		</div>
		<!-- <keep-alive> -->
		  <router-view />
		<!-- </keep-alive> -->
	</div>
</template>

<script>
	export default {
		data(){
			return {
				colors: ['#0D51F3', '#537DE6', '#19C7F6']
			}
		},
		created(){
		},
		methods:{
		}
	}
</script>

<style scoped lang="scss">
	.top{
		background-image: url(../assets/top.gif);
		position: fixed;
		top: 0px;
		left: 0px;
		right: 0px;
		height: 86px;
		z-index: 100;
		.top-title{
			width: 436px;
			height: auto;
			object-fit: contain;
			position: absolute;
			top: 16px;
			left: 50%;
			transform: translate(-50%, 0%);
		}
		.breathing-light{
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			display: flex;
			gap: 8px;
			align-items: center;
			.light-block{
				width: 10px;
				height: 10px;
				border-radius: 2px;
				animation: breathe 2s ease-in-out infinite, colorChange 3s ease-in-out infinite;
			}
		}
		.left-light{
			left: 36px;
		}
		.right-light{
			right: 36px;
			.right-block{
				animation: breathe 2s ease-in-out infinite, colorChangeReverse 3s ease-in-out infinite;
			}
		}
	}
	
	@keyframes breathe {
		0%, 100% {
			opacity: 0.3;
			transform: scale(1);
		}
		50% {
			opacity: 1;
			transform: scale(1.2);
		}
	}
	
	@keyframes colorChange {
		0% {
			background-color: #0D51F3;
		}
		33.33% {
			background-color: #537DE6;
		}
		66.66% {
			background-color: #19C7F6;
		}
		100% {
			background-color: #0D51F3;
		}
	}
	
	@keyframes colorChangeReverse {
		0% {
			background-color: #19C7F6;
		}
		33.33% {
			background-color: #537DE6;
		}
		66.66% {
			background-color: #0D51F3;
		}
		100% {
			background-color: #19C7F6;
		}
	}
</style>